import React from 'react'
import { observer } from "mobx-react";
import { ActionDto, ReviewEmployeeAccountDto } from 'src/stores/models/qarFormModels';
import { TableCell, TableRow, TextField } from '@material-ui/core';
import { EmployeeReviewActions } from 'src/stores/models/enums';
import { useStores } from 'src/stores/rootStore';


export const QARFormCommentInput = observer(({ employeeAccount, action, actionChanges }:
    { employeeAccount: ReviewEmployeeAccountDto, action: ActionDto, actionChanges: ActionDto }) => {

        const { qarFormStore } = useStores();

    function shouldShowCommentRow(actionChanges: ActionDto): string {

        if (actionChanges.name !== EmployeeReviewActions.Change && actionChanges.name !== EmployeeReviewActions.Revoked) {
            return 'qar-form-comment-row-hidden';
        }

        return '';
    }

    const shouldBeReadOnly = () => {
        return (action.name === EmployeeReviewActions.Change || action.name === EmployeeReviewActions.Revoked) &&
               actionChanges.name === action.name
    }

    const handleFieldChange = (event: any) => {
        actionChanges.comment = event.target.value;

        if (actionChanges.valid === false) {
            actionChanges.valid = true
        }
    }

    const commentRow = (isDisabled: boolean) =>{

        return (<TableRow className={shouldShowCommentRow(actionChanges)}>
                <TableCell colSpan={9}>
                <TextField label= {shouldBeReadOnly() || isDisabled ? "Original ticket description" : "Ticket description"}
                        variant='standard'
                        value={actionChanges.comment ?? ''}
                        onChange={handleFieldChange}
                        disabled={isDisabled || shouldBeReadOnly()}
                        inputProps={{ style: { textAlign: 'left', margin: '0 10px' }, className: 'default-mui', readOnly: shouldBeReadOnly() }}
                        InputLabelProps={{ shrink: true }}
                        style={{ width: "100%" }}
                        required
                        multiline={true}
                        minRows={1}
                        maxRows={5}
                        helperText={"'Revoked' and 'Change' require justification."}
                        error={actionChanges.valid === false}
                        className="comment"
                    />
                    {/* <p>Current comment for {EmployeeReviewActions[actionChanges.name]} ticket on {employeeAccount.username}: {actionChanges.comment}</p> */}
                </TableCell>
            </TableRow>
       )
    }

    const renderFormControl = () => {
        // if (action.name !== EmployeeReviewActions.MissingAction) {

        //     if (action.name === EmployeeReviewActions.Change || action.name === EmployeeReviewActions.Revoked) {
        //         return (
        //             <TableRow>
        //                 <TableCell colSpan={5}>
        //                     <p>{action.comment}</p>
        //                 </TableCell>
        //             </TableRow>
        //         );
        //     }

        //     // keep silent
        //     return <></>
        // }

        if(qarFormStore.selectedQuarter?.isManagerReviewAdminCompleted) {
            return commentRow(true)
        }

        if(
            qarFormStore.selectedQuarter && 
            new Date(qarFormStore.selectedQuarter.reviewDeadline) < new Date() && 
            (action.comment && action.comment.trim() !== "") && 
            (action.ticketId && action.ticketId.trim() !== "")
        ) {
            return commentRow(true)
        }

        return commentRow(false)
    }

    return (
        <>
            {renderFormControl()}
        </>
    );

});
